import { GardeningTaskGardenerViewDocument } from "./gardener-view/gardening-task-gardener-view.model";

export const collapseCustomerGardeningTasksToTheMostRelevantTask = (gardeningTasks: GardeningTaskGardenerViewDocument[]): GardeningTaskGardenerViewDocument | null => {
    const sortedGardeningTasks = gardeningTasks.sort((a, b) => {
        const aDate = a.history.find(x => x.event === "gardener accepted task" || x.event === "task given to gardener")?.date;
        const bDate = b.history.find(x => x.event === "gardener accepted task" || x.event === "task given to gardener")?.date;

        if ( !aDate && bDate ) return -1;
        if ( aDate && !bDate ) return 1;
        if ( !aDate && !bDate ) return 0;

        if ( aDate && bDate ) {
            if ( aDate < bDate ) return -1;
            if ( aDate > bDate ) return 1;
        }

        return 0;
    }).reverse();

    const activeGardeningTask = sortedGardeningTasks.find(gardeningTask => gardeningTask.status === "found gardener" && gardeningTask.working.status !== "has finished working");
    if ( activeGardeningTask ) return activeGardeningTask;

    const inactiveGardeningTask = sortedGardeningTasks.find(gardeningTask => gardeningTask.status === "found gardener" && gardeningTask.working.status === "has finished working");

    return inactiveGardeningTask ?? null;
}

export const collapseGardeningTasksToTheMostRelevantTaskPerCustomer = (gardeningTasks: GardeningTaskGardenerViewDocument[]): GardeningTaskGardenerViewDocument[] => {
    const customerIds = Array.from(new Set(gardeningTasks.map(x => x.customer.id)));

    return customerIds.reduce((total, customerId) => {
        const customerGardeningTasks = gardeningTasks.filter(x => x.customer.id === customerId);
        const gardeningTask = collapseCustomerGardeningTasksToTheMostRelevantTask(customerGardeningTasks);
        if ( !gardeningTask ) return total;

        return [...total, gardeningTask];
    }, [] as GardeningTaskGardenerViewDocument[])
}
